<template>
  <div class="radar-chart">
    <div class="student-pie" :style="widthStyle()">
      <div class="list-view-btop" :style="widthStyle()">
        <div class="list-view-buttonlist" :style="widthStyle()">
          <div class="stuPieDomDiv" :class="isNationwide ? 'stuPieDomDiv2' : ''" :style="widthStyle()">
            <div ref="stuPieDom" v-if="isShow" class="stuPieDom" :style="widthStyle()"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="stu-btm" v-if="isNationwide">
      <div class="stu-btm-div" v-for="(item, index) in optionsCon.color" :key="index">
        <div class="div-bg" :style="{ backgroundColor: item }"></div>
        <div class="div-txt">{{ optionsCon.data[index] }}</div>
      </div>
    </div> -->
    <div class="tips-view" :class="isNationwide ? 'tips2' : ''">
      <div class="tips-view-container">
        <div class="tips-img">
          <img src="@/assets/images/home/Tips_Orange.png" alt="" />
        </div>
        <div class="tips-text">提示：</div>
        <div class="tips-content">以上三个维度可分别点击查看</div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入 echarts 核心模块，核心模块提供了 echarts  使用必须要的接口。
import * as echarts from 'echarts'
export default {
  name: 'RadarChart',
  data () {
    return {
      myChart: {},
      isShow: true,
      detail: {},
      option: {},
      optionProvince: {},
      optionCountry: {},
      optionsCon: {
        color: ['#0F68B2', '#FBE058', '#EC3636'],
        data: ['当月平均AIFV', '上月平均AIFV', '全国当月平均AIFV']
      }
    }
  },
  props: {
    initData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    titlePosition: {
      type: String || Number,
      default: 'center'
    },
    // 是否是全国  true为全国 false为全省
    isNationwide: {
      type: Boolean,
      default: false
    },
    activeTxt: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
  },
  watch: {
    initData: {
      handler (newValue, oldValue) {
        if (newValue) {
          this.detail = { ...newValue }
          this.createRadar()
        }
      },
      deep: true // 深度监听
      //   immediate: true
    }
  },
  methods: {
    widthStyle () {
      return {width: this.width}
    },
    createRadar () {
      this.$nextTick(() => {
        let stuPieDom = this.$refs.stuPieDom
        let myChart = echarts.init(stuPieDom)
        this.initOption(stuPieDom.clientWidth)
        myChart.setOption(this.option)
      })
    },
    initOption (divWidth) {
      console.log(this.activeTxt, '=-=-')
      if (this.isNationwide === true) {
        this.optionCountry = {
          color: this.optionsCon.color,
          radar: {
            axisLine: {
              show: false
            },
            splitNumber: 6,
            center: ['50%', '40%'],
            name: {
              formatter: function (value) {
                return '{a|' + value.split('\n')[0] + '}\n{b|' + value.split('\n')[1] + '}'
              },
              // 统一设置颜色字体
              textStyle: {
                color: '#5B5F6A',
                fontSize: 12,
                align: 'center',
                padding: [-36, 0]
              }
            },
            nameGap: 40,
            splitArea: {
              areaStyle: {
                color: 'rgba(0,0,0,0)',
                opacity: 1
              }
            },
            radius: divWidth / 3.81,
            indicator: [
              { name: 'FOT\n（稳定贴靠）', max: 6 },
              { name: '碎点\n（穿刺位置）', max: 6 },
              { name: '手术时间\n（高效消融）', max: 6 },
              { name: '放电时间占比\n(鞘管微调)', max: 6 },
              { name: 'Gap\n（逐点连续）', max: 6 },
              { name: 'AI\n（前庭消融）', max: 6 }
            ]
          },
          series: [
            {
              type: 'radar',
              symbolSize: 0,
              data: [
                {
                  value: [this.detail.countryAvgAifv.aifv4, this.detail.countryAvgAifv.aifv2, this.detail.countryAvgAifv.aifv3, this.detail.countryAvgAifv.aifv6, this.detail.countryAvgAifv.aifv1, this.detail.countryAvgAifv.aifv5],
                  name: `${this.activeTxt}` === '30' ? '全国当月平均AIFV' : '全国当季平均AIFV',
                  areaStyle: {
                    opacity: 0.5
                  },
                  lineStyle: {
                    type: 'dashed',
                  },
                },
                {
                  value: [this.detail.prevAifv.aifv4, this.detail.prevAifv.aifv2, this.detail.prevAifv.aifv3, this.detail.prevAifv.aifv6, this.detail.prevAifv.aifv1, this.detail.prevAifv.aifv5],
                  name: `${this.activeTxt}` === '30' ? '上月平均AIFV' : '上季平均AIFV',
                  areaStyle: {
                    opacity: 0.5
                  },
                  lineStyle: {
                    type: 'dashed',
                  },
                },
                {
                  value: [this.detail.currentAifv.aifv4, this.detail.currentAifv.aifv2, this.detail.currentAifv.aifv3, this.detail.currentAifv.aifv6, this.detail.currentAifv.aifv1, this.detail.currentAifv.aifv5],
                  name: `${this.activeTxt}` === '30' ? '当月平均AIFV' : '当季平均AIFV',
                  areaStyle: {
                    opacity: 0.5
                  },
                  lineStyle: {
                    type: 'dashed',
                  },
                },
              ]
            }
          ],
          legend: {
            bottom: 20,
            left: 18,
            width: '20%',
            data: [{
              name: `${this.activeTxt}` === '30' ? '当月平均AIFV' : '当季平均AIFV',
              itemStyle: {
                color: '#EC3636',
              },
            }, {
              name: `${this.activeTxt}` === '30' ? '上月平均AIFV' : '上季平均AIFV',
              itemStyle: {
                color: '#FBE058',
              },
            }, {
              name: `${this.activeTxt}` === '30' ? '全国当月平均AIFV' : '全国当季平均AIFV',
              itemStyle: {
                color: '#0F68B2',
              },
            }],
          }
        }
        this.option = JSON.parse(JSON.stringify(this.optionCountry))
      } else {
        this.optionProvince = {
          title: {
            text: 'AIFV报告分析',
            textStyle: {
              fontSize: '12',
              color: '#000',
              lineHeight: '18'
            },
            top: '15',
            left: this.titlePosition
          },
          color: ['#F1EFED', '#D5CFC9', '#EB1700'],
          radar: {
            axisLine: {
              show: false
            },
            splitNumber: 6,
            center: ['50%', '47.5%'],
            name: {
            // 统一设置颜色字体
              textStyle: {
                color: '#5B5F6A',
                fontSize: 16,
                align: 'center',
                padding: [-30, 0]
              }
            },
            nameGap: 40,
            splitArea: {
              areaStyle: {
                color: 'rgba(0,0,0,0)',
                opacity: 1
              }
            },
            radius: 110,
            indicator: [
              { name: 'FOT\n（稳定贴靠）', max: 6 },
              { name: '碎点\n（穿刺位置）', max: 6 },
              { name: '手术时间\n（高效消融）', max: 6 },
              { name: 'PVI+\n（线性消融）', max: 6 },
              { name: 'Gap\n（逐点连续）', max: 6 },
              { name: 'AI\n（前庭消融）', max: 6 }
            ]
          },
          series: [
            {
              type: 'radar',
              symbolSize: 0,
              data: [
                {
                  value: [this.detail.prevAifv.aifv4, this.detail.prevAifv.aifv2, this.detail.prevAifv.aifv3, this.detail.prevAifv.aifv6, this.detail.prevAifv.aifv1, this.detail.prevAifv.aifv5],
                  name: '上季度平均AIFV',
                  areaStyle: {
                    opacity: 0.7
                  },
                  lineStyle: {
                    width: 'rgba(0, 0, 0, 0)'
                  }
                },
                {
                  value: [this.detail.provinceAvgAifv.aifv4, this.detail.provinceAvgAifv.aifv2, this.detail.provinceAvgAifv.aifv3, this.detail.provinceAvgAifv.aifv6, this.detail.provinceAvgAifv.aifv1, this.detail.provinceAvgAifv.aifv5],
                  name: '省当季平均AIFV   ',
                  areaStyle: {
                    opacity: 0.7
                  },
                  lineStyle: {
                    width: 'rgba(0, 0, 0, 0)'
                  }
                },
                {
                  value: [this.detail.currentAifv.aifv4, this.detail.currentAifv.aifv2, this.detail.currentAifv.aifv3, this.detail.currentAifv.aifv6, this.detail.currentAifv.aifv1, this.detail.currentAifv.aifv5],
                  name: '当季度平均AIFV',
                  areaStyle: {
                    opacity: 0.7
                  },
                  lineStyle: {
                    width: 'rgba(0, 0, 0, 0)'
                  }
                }
              ]
            }
          ],
          legend: {
            bottom: 20,
            data: ['当季度平均AIFV', '上季度平均AIFV', '省当季平均AIFV   ']
          }
        }
        this.option = JSON.parse(JSON.stringify(this.optionProvince))
      }
    }
  },
  mounted () {
    if (Object.keys(this.initData).length <= 0) {
      this.detail = {
        currentAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        },
        prevAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        },
        countryAvgAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        },
        provinceAvgAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        }
      }
    } else {
      this.detail = { ...this.initData }
    }
    this.createRadar()
  }
}
</script>

<style lang="less" scoped>
.radar-chart {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  position: relative;
  padding-bottom: 12px;
  box-sizing: border-box;
  //   justify-content: center;
}

.student-pie {
  width: 351px;
  max-width: 100%;
  overflow-x: hidden;
  background-color: #f0f1f6;
  display: flex;
  flex-wrap: wrap;

  .list-view-titel {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;
    // padding: 20px 15px 16px 15px;
    // flex-wrap: wrap;
    align-content: center;
    position: relative;

    .list-view-vertical {
      width: 4px;
      height: 12px;
      background-color: #EB1700;
      border: 1px solid #EB1700;
      border-radius: 2px;
      margin-right: 7px;
    }

    .list-view-subtitel {
      display: flex;
      width: 80px;
      font-size: 15px;
      font-weight: 800;
      color: #1f333f;
      line-height: 15px;
    }

    .list-view-buttonlist {
      width: 220px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      margin-left: 20px;

      .list-view-button {
        display: inline-block;
        width: 40px;
        font-size: 12px;
        background: #ffffff;
        border: 1px solid #ffffff;
        border-radius: 5px;
        text-align: center;
      }

      .list-view-buttonclick {
        color: #EB1700;
        display: inline-block;
        width: 40px;
        font-size: 12px;
        background: #ffffff;
        border: 1px solid #ffffff;
        border-radius: 5px;
        text-align: center;
      }
    }
  }

  .list-view-btop {
    background: #ffffff;
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    border-radius: 5px;

    .list-view-buttonlist {
      text-align: center;
      width: 216px;

      .list-view-leftbutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        border-left: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        text-align: center;
      }

      .list-view-leftbuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border-left: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        text-align: center;
      }

      .list-view-midbutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border: 1px solid #EB1700;
        text-align: center;
      }

      .list-view-midbuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border: 1px solid #EB1700;
        text-align: center;
      }

      .list-view-midtwobutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-right: 1px solid #EB1700;
        text-align: center;
      }

      .list-view-midtwobuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-right: 1px solid #EB1700;
        text-align: center;
      }

      .list-view-rightbutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border-right: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
        text-align: center;
      }

      .list-view-rightbuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border-right: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
        text-align: center;
      }
    }

    .list-view-bottom {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 16px 16px 16px 16px;
      flex-wrap: wrap;
      align-content: center;
      position: relative;

      .list-view-tips {
        display: flex;
        justify-content: flex-end;
        width: 319px;
        font-size: 12px;
        font-weight: 500;
        color: #1f333f;
        line-height: 11px;

        .list-view-roundf {
          line-height: 11px;
          display: flex;
          align-items: center;

          .list-view-round {
            width: 7px;
            height: 7px;
            background: #ffffff;
            border-radius: 50%;
            border: 2px solid #EB1700;
            margin-right: 8px;
          }
        }
      }
    }

    .stuPieDomDiv {
      width: 351px;
      height: 441px;
      background: #ffffff;

      &.stuPieDomDiv2 {
        width: 335px;
        height: 360px;

        .stuPieDom {
          width: 335px;
          height: 360px;
        }
      }

      .stuPieDom {
        width: 351px;
        height: 441px;
        text-align: center;
        background: #ffffff;
        border-radius: 5px;
      }
    }
  }

  .list-table {
    background-color: #fff;
    margin-top: 8px;
    padding: 0 6px;
    box-sizing: border-box;
    width: 100%;

    .tilte-txt {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #2b2b2b;
      font-weight: 600;
      height: 60px;

      .num {
        font-size: 22px;
        color: #2b2b2b;
        font-weight: bold;
        margin-left: 10px;
      }
    }

    .table-tr {
      display: flex;
      align-items: center;
      height: 32px;
      padding-left: 10px;
      box-sizing: border-box;
      margin-bottom: 12px;
      justify-content: space-between;

      &.th {
        background-color: #f0f1f6;
      }

      &.tr {
        height: 14px;
        line-height: 14px;
        margin-bottom: 16px;
      }

      .table-td {
        font-size: 10px;
        color: #2b2b2b;
        font-weight: 400;
        width: 25%;

        &:nth-last-child(1) {
          width: 50px;
        }

        &.table-th {
          font-size: 12px;
        }
      }
    }
  }
}

.stu-btm {
  position: absolute;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  bottom: 34px;

  .stu-btm-div {
    width: 50%;
    display: flex;
    margin-bottom: 8px;
    padding-left: 18px;
    box-sizing: border-box;

    .div-bg {
      width: 24px;
      height: 15px;
      margin-right: 2px;
      border-radius: 4px;
    }

    .div-txt {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 12px;
      color: #5B5F6A;
    }
  }
}

.tips-view {
  width: 100%;
  height: 47px;
  margin-top: -10px;
  background-color: #ffffff;
  &.tips2 {
    height: auto;
    // margin-top: 10px;
    .tips-view-container {
      height: auto;
      justify-content: flex-start;
      padding-left: 18px;
      box-sizing: border-box;
    }
  }

  .tips-view-container {
    // width: 319px;
    height: 47px;
    display: flex;
    // align-items: center;
    // margin-left: 65px;
    justify-content: center;
    text-align: center;

    .tips-img {
      width: 14px;
      height: 16px;
      margin-right: 5px;
      line-height: 17px;

      img {
        width: 14px;
        height: 16px;
      }
    }

    .tips-text {
      // width: 36px;
      height: 17px;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      color: #EB1700;
      line-height: 17px;
    }

    .tips-content {
      height: 17px;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      color: #EB1700;
      line-height: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RadarChart.vue